export interface DateFormInitialVal {
  preference: DatePreference;
  date: string;
  format: string;
  rangeStart: string;
  rangeEnd: string;
  season: string;
  year: string;
  hideDate: boolean;
}

export interface DateDisplayProps {
  onSubmit: (values: WeddingDatePreferences) => void;
  onError: (error: any) => void;
  config?: Partial<DateFormConfig>;
}

export interface DateFormConfig {
  allowFormat: boolean;
  showTBA: boolean;
  defaultView: DatePreference;
}

export type ObjectMap = { [key: string]: any };

export interface PillProps {
  currentView: DatePreference | null;
  onClick: (pref: DatePreference) => void;
  config: DateFormConfig;
}

export interface DateFormProps {
  currentView: DatePreference | null;
  config?: DateFormConfig;
}

export enum DatePreference {
  Range = 'Range',
  Exact = 'Exact',
  Tba = 'TBA',
  Season = 'Season',
  None = 'None',
}

export enum SeasonName {
  Fall = 'Fall',
  Winter = 'Winter',
  Spring = 'Spring',
  Summer = 'Summer',
}

export type UpdateWeddingDatePreferencesArgs = {
  preference: DatePreference;
  /** Use preference instead */
  hideDate?: boolean;
  hideCountdown?: boolean;
  season?: SeasonName;
  year?: number;
  date?: string;
  format?: string;
  rangeStart?: string;
  rangeEnd?: string;
};

export type WeddingDatePreferences = {
  __typename?: 'WeddingDatePreferences';
  year?: number | null;
  season?: SeasonName | null;
  hideDate?: boolean | null;
  hideCountdown?: boolean | null;
  weddingDate?: string | null;
  weddingDateFormat?: string | null;
  weddingDateRangeStart?: string | null;
  weddingDateRangeEnd?: string | null;
  datePreference: DatePreference;
};
